import { Route, Routes } from "react-router-dom";
import ReturnPath from "components/routes/ReturnPath";
import Charters from "./Charters";
import SpotSalesCharters from "./SpotSalesCharters";
import SpotSalesCharter from "./SpotSalesCharter";
import SalesCharters from "./SalesCharters";
import SalesCharterDetails from "./SalesCharterDetails";
import PurchaseCharterDetails from "./PurchaseCharterDetails";

export const ChartersIndex = () => {
	return (
		<Routes>
			<Route index element={<Charters />} />
		</Routes>
	);
};

export const SpotSalesChartersIndex = () => {
	return (
		<Routes>
			<Route index element={<SpotSalesCharters />} />
			<Route path='/:id/details' element={<SpotSalesCharter />} />
		</Routes>
	);
};

export const SalesChartersIndex = () => {
	return (
		<Routes>
			<Route element={<ReturnPath primaryPath="salescharters" />}>
				<Route index element={<SalesCharters />} />
				<Route path='/:id/details' element={<SalesCharterDetails />} />
				<Route path='/create' element={ <SalesCharterDetails />} />
			</Route>
		</Routes>
	);
};

export const PurchaseChartersIndex = () => {
	return (
		<Routes>
			<Route element={<ReturnPath primaryPath="purchasecharters" />}>
				<Route path='/:id/details' element={<PurchaseCharterDetails />} />
			</Route>
		</Routes>
	);
};

